<template>
  <div>
    <div class="ask-bot" @click="toggleModal()">
      <b-icon icon="tune-variant"></b-icon>
    </div>
    <b-modal v-model="showModal" @close="toggleModal()">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Change your student settings</p>
        </header>
        <section class="modal-card-body">
          <b-field label="">
            <b-checkbox v-model="applicationFilters.activeStudents">
              Also show archived students
            </b-checkbox>
            <b-tooltip
              type="is-light"
              :triggers="['hover', 'click']"
              multilined
              auto-close
              position="is-right"
            >
              <template v-slot:content>
                <span>
                  A student is considered archived once the Final payment has
                  been made for that student.
                </span>
              </template>
              <b-icon icon="information" type="is-info" />
            </b-tooltip>
          </b-field>

          <b-field v-if="isManagement" label="">
            <b-checkbox v-model="applicationFilters.showInactiveStudents">
              Also show unapproved students
            </b-checkbox>
          </b-field>

          <b-field label="">
            <b-checkbox v-model="applicationFilters.showDraftStudents">
              Also show draft students
            </b-checkbox>
          </b-field>

          <b-field v-if="showModal" label="Intake">
            <multiselect
              v-model="applicationFilters.intake"
              :options="activeIntakes"
              track-by="value"
              label="value"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              placeholder="Choose one or multiple intakes"
              :preselect-first="false"
            >
            </multiselect>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <b-button label="Close" @click="toggleModal()" />
          <b-button
            label="Save filters"
            type="is-primary"
            @click="saveFilters()"
          />
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import UtilService from '../../services/util';
import Multiselect from 'vue-multiselect';

export default {
  name: 'settings',
  props: ['openByDefault'],
  components: {
    Multiselect,
  },
  data() {
    return {
      applicationFilters: {
        showInactiveStudents: false,
        unapprovedStudents: false,
        showDraftStudents: false,
        intake: null,
      },
      showModal: false,
    };
  },
  watch: {
    openByDefault: {
      handler(value) {
        if (value) {
          this.toggleModal();
        }
      },
      deep: true,
    },
  },
  mounted() {
    const appFiltersCopy = UtilService.deepCopy(this.applicationFilters);
    this.applicationFilters = localStorage.getItem('applicationFilters')
      ? JSON.parse(localStorage.getItem('applicationFilters'))
      : appFiltersCopy;
    this.applicationFilters.showDraftStudents = this.isManagement
      ? this.applicationFilters.showDraftStudents
      : null;
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isManagement() {
      return UtilService.isManagement();
    },
    activeIntakes() {
      return this.$store.state.application_filter.filterOptions.intake;
    },
  },
  methods: {
    saveFilters() {
      const filters = {
        ...this.applicationFilters,
        userId: this.currentUser.id,
      };
      localStorage.setItem('applicationFilters', JSON.stringify(filters));
      location.reload();
    },
    toggleModal() {
      this.showModal = !this.showModal;
      this.$emit('openFilters', this.showModal);
      if (!this.showModal && this.openByDefault) {
        this.saveFilters();
      }
    },
  },
};
</script>

<style scoped>
.ask-bot {
  position: fixed !important;
  z-index: 100000;
  right: 10px;
  bottom: 10px;
  border-radius: 50%;
  width: 60px;
  height: 60px;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
}

.ask-bot > img {
  width: 40px;
  border-radius: 50%;
}

deep-chat,
.ask-bot {
  background: linear-gradient(
    90deg,
    rgb(239, 242, 247) 0%,
    7.60286%,
    rgb(237, 240, 249) 15.2057%,
    20.7513%,
    rgb(235, 239, 248) 26.297%,
    27.6386%,
    rgb(235, 239, 248) 28.9803%,
    38.2826%,
    rgb(231, 237, 249) 47.585%,
    48.1216%,
    rgb(230, 236, 250) 48.6583%,
    53.1306%,
    rgb(228, 236, 249) 57.6029%,
    61.5385%,
    rgb(227, 234, 250) 65.4741%,
    68.7835%,
    rgb(222, 234, 250) 72.093%,
    75.7603%,
    rgb(219, 230, 248) 79.4275%,
    82.8265%,
    rgb(216, 229, 248) 86.2254%,
    87.8354%,
    rgb(213, 228, 249) 89.4454%,
    91.8605%,
    rgb(210, 226, 249) 94.2755%,
    95.4383%,
    rgb(209, 225, 248) 96.6011%,
    98.3005%,
    rgb(208, 224, 247) 100%
  );
}
</style>
